import { BookmakerImport } from "../icons";
import Create from "./Create";
import List from "./List";
import Show from "./Show";

export default {
	options: {
		group: "bookmakers",
		roles: ["admin", "affiliate_manager"],
	},
	icon: BookmakerImport,
	list: List,
	create: Create,
	show: Show,
};
